import { render, staticRenderFns } from "./AddEditCurator.vue?vue&type=template&id=08936007"
import script from "./AddEditCurator.vue?vue&type=script&lang=js"
export * from "./AddEditCurator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports